var EDIT_MODE_CLASS = "system-links--edit";
var HIDDEN_ITEMS_EXPANDED_CLASS = "system-links__hidden-items--expanded";

var system_links_init_run = false;

function initSystemLinksComponents() {
    var is_authoring = $('.aem_author_mode').length > 0;

    if(!system_links_init_run && !is_authoring) {
        try {
            loadAndDisplaySystemLinks();
            bindSystemLinksEvents();
            //Set run toggle
            system_links_init_run = true;
        } catch (e) {
            console.error("Error when trying to init system links components!",e);
        }
    }
}
function loadAndDisplaySystemLinks() {
    var all_system_links_components = $(".system-links");
    all_system_links_components.each(function ()  {
        var current_system_link_component = $(this);
        loadSystemLinksOrder(current_system_link_component);

        var current_system_link_component_items = current_system_link_component.find(".system-links__item");

        //Fade the items in *this* system links component one after another
        fadeToRecursive(150, 1, $.makeArray(current_system_link_component_items));
    });
}

function bindSystemLinksEvents() {
    $(".system-links__show-hidden-button").on("click", function (event) {
        event.preventDefault();
        var show_hidden_button_clicked = $(this);
        var show_hidden_button_clicked_icon = show_hidden_button_clicked.find(".system-links__show-hidden-button-icon");
        var parent_system_links_component = show_hidden_button_clicked.closest(".system-links");
        var hidden_items_container = parent_system_links_component.find(".system-links__hidden-items");
        if(parent_system_links_component.hasClass(EDIT_MODE_CLASS)) {
            //is in edit mode so don't expand or collapse - also the expend/collapse thing will be hidden.
            return;
        }
        if (hidden_items_container.hasClass(HIDDEN_ITEMS_EXPANDED_CLASS)) {
            //collapse hidden items
            hidden_items_container.removeClass(HIDDEN_ITEMS_EXPANDED_CLASS);
            hidden_items_container.slideUp();
            show_hidden_button_clicked_icon.switchClass("fa-chevron-up","fa-chevron-down");
            show_hidden_button_clicked.find(".system-links__show-hidden-button-text").text(show_hidden_button_clicked.data("expand-text"));
        } else {
            //expand hidden items
            hidden_items_container.addClass(HIDDEN_ITEMS_EXPANDED_CLASS);
            hidden_items_container.slideDown();
            show_hidden_button_clicked_icon.switchClass("fa-chevron-down", "fa-chevron-up");
            show_hidden_button_clicked.find(".system-links__show-hidden-button-text").text(show_hidden_button_clicked.data("collapse-text"));
        }
    });

    $(".system-links__configure-button").on("click", function (event) {
        event.preventDefault();
        var system_links_component = $(this).closest(".system-links");
        var system_links_item_containers = system_links_component.find(".system-links__items-container");
        var all_system_links = system_links_component.find(".system-links__item");

        if (system_links_component.hasClass(EDIT_MODE_CLASS)) {
            //cancel edit mode
            system_links_component.removeClass(EDIT_MODE_CLASS);
            // disable sorting
            system_links_item_containers
                .sortable({
                    disabled: true
                })
                .enableSelection();
            //so they can be scrolled against on mobile..
            all_system_links.removeClass("ui-sortable-handle");
            //disable keyboard shortcuts
            all_system_links.off("keydown.move_link");
        } else {
            //start edit mode
            system_links_component.addClass(EDIT_MODE_CLASS);
            //enable sorting
            system_links_item_containers
                .sortable({
                    disabled: false,
                    connectWith: ".system-links__items-container",
                    items: ".system-links__item",
                    update: function (event, ui) {
                        saveSystemLinksOrder(system_links_component);
                    }
                })
                .disableSelection();

            //enable keyboard shortcuts
            all_system_links.on("keydown.move_link", function (event) {
                var current_link_item = $(this);
                var parent_container_type = current_link_item.closest(".system-links__items-container").data("container-type");
                var new_item_loc = current_link_item;
                // left or up
                if (event.keyCode == 37 || event.keyCode == 38) {
                    if (current_link_item.prev(".system-links__item").length === 0) {
                        if (parent_container_type === "hidden") {
                            var visible_last_item = system_links_component.find(".system-links__visible-items .system-links__item").last();
                            new_item_loc = current_link_item.insertAfter(visible_last_item);
                        }
                    } else {
                        new_item_loc = current_link_item.insertBefore(current_link_item.prev());
                    }
                    saveSystemLinksOrder(system_links_component);
                }
                // right or down
                if (event.keyCode == 39 || event.keyCode == 40) {
                    if (current_link_item.next(".system-links__item").length === 0) {
                        //At the end of the container, only move if is the visible container to the hidden container
                        if (parent_container_type === "visible") {
                            var hidden_first_item = system_links_component.find(".system-links__hidden-items .system-links__item").first();
                            new_item_loc = current_link_item.insertBefore(hidden_first_item);
                        }
                    } else {
                        new_item_loc = current_link_item.insertAfter(current_link_item.next());
                    }
                    saveSystemLinksOrder(system_links_component);
                }
                new_item_loc.find(".system-links__item-link").focus();
            });
        }
    });
}

function loadSystemLinksOrder(system_link_component) {
    var local_storage_system_links = getUserProfileSystemLinks();
    var system_link_component_id = system_link_component.find(".js-system-link-id").val();
    if(local_storage_system_links.hasOwnProperty(system_link_component_id)) {
        //Get system links object from local storage
        var saved_system_links = local_storage_system_links[system_link_component_id];
        var sync_local_storage = false;
        if(saved_system_links.hasOwnProperty("visible_items") && saved_system_links.visible_items.length > 0) {
            saved_system_links.visible_items = sortSystemLinksById(saved_system_links.visible_items, system_link_component, system_link_component.find(".system-links__visible-items"));
            sync_local_storage = true;
        }
        if(saved_system_links.hasOwnProperty("hidden_items") && saved_system_links.hidden_items.length > 0) {
            saved_system_links.hidden_items = sortSystemLinksById(saved_system_links.hidden_items, system_link_component, system_link_component.find(".system-links__hidden-items"));
            sync_local_storage = true;
        }

        if(sync_local_storage) {
            //We could do array comparisons and fancy filtering - but it is much more simple to replace with id's we know match valid elements after a load.
            //We could call saveSystemLinksOrder(system_link_component) after a load, but then we will miss the opportunity to highlight items that might be new in the future
            saveUserProfileSystemLinks(local_storage_system_links);
        }
    }
}

//NOTE(JD) - I didn't end up using my utility function sortDomElementsById() because I needed to go up one level as the ID's are attached to a child of the object I want to move.
function sortSystemLinksById(array_of_ids, system_link_component, item_container) {
    var valid_ids = [];
    while (array_of_ids.length) {
        var system_link_item_id = array_of_ids.pop();
        var system_link_item = system_link_component.find("#" + system_link_item_id).closest(".system-links__item");
        if(system_link_item.length > 0) {
            item_container.prepend(system_link_item);
            //collect ID's that actually match an element, return them to clean-up any ID's that might be stale
            valid_ids.unshift(system_link_item_id);
        }
    }
    return valid_ids;
}

//Save the user-defined order of the system links
function saveSystemLinksOrder(system_link_component) {
    var local_storage_system_links = getUserProfileSystemLinks();
    var system_link_component_id = system_link_component.find(".js-system-link-id").val();
    var visible_item_ids = system_link_component.find(".system-links__visible-items .system-links__item-link")
        .map(function () {
            return this.id;
        })
        .get();
    var hidden_item_ids = system_link_component.find(".system-links__hidden-items .system-links__item-link")
        .map(function () {
            return this.id;
        })
        .get();

    local_storage_system_links[system_link_component_id] = {
        visible_items: visible_item_ids,
        hidden_items: hidden_item_ids
    };

    saveUserProfileSystemLinks(local_storage_system_links);
}

